/**
 * @voltxampere/ui — AnnotationTool (Sprint 14)
 *
 * The text annotation flow has two halves:
 *
 *   1. THIS TOOL captures the user's click on an empty canvas
 *      point, snaps it to the annotation grid (16 px to match
 *      Sprint 13 drag grid) and notifies the host via
 *      `onRequestEdit(position)`.
 *   2. THE HOST (`<vxa-canvas>`) opens an inline `<input>`
 *      overlay positioned at the snapped point, captures the
 *      typed text, and pushes an `AddAnnotationCommand` on
 *      Enter.
 *
 * Splitting the responsibilities like this keeps the tool pure
 * (no DOM ownership, easy to unit-test) and lets the host
 * reuse the same overlay UI for Sprint 15 box / arrow editing.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const ANNOTATION_GRID_SIZE = 16;
export class AnnotationTool {
    opts;
    id = "annotation";
    cursor = "crosshair";
    hoverPosition = null;
    constructor(opts = {}) {
        this.opts = opts;
    }
    ghostNodes() {
        if (!this.hoverPosition)
            return [];
        return [
            {
                kind: "annotation-edit",
                id: "annotation-tool-ghost",
                position: this.hoverPosition,
            },
        ];
    }
    onPointerMove(e, ctx) {
        const world = ctx.worldFromEvent(e);
        this.hoverPosition = ctx.viewport.snapToGrid(world, ANNOTATION_GRID_SIZE);
        ctx.invalidate();
    }
    onPointerDown(e, ctx) {
        if (e.button !== 0)
            return;
        const world = ctx.worldFromEvent(e);
        const snapped = ctx.viewport.snapToGrid(world, ANNOTATION_GRID_SIZE);
        this.opts.onRequestEdit?.(snapped);
        // Hand the workflow over to the host's text-input overlay;
        // the tool itself exits so the user is back on SelectTool by
        // the time they finish typing.
        this.hoverPosition = null;
        this.opts.onExit?.();
    }
    onKeyDown(e, _ctx) {
        if (e.key === "Escape") {
            this.hoverPosition = null;
            this.opts.onExit?.();
        }
    }
    onLeave(_ctx) {
        this.hoverPosition = null;
    }
    /** Test surface — peek at the snapped hover position. */
    get currentHoverPosition() {
        return this.hoverPosition;
    }
}
//# sourceMappingURL=annotation.js.map